export default "__VITE_PUBLIC_ASSET__061d3368__"